import * as actionTypes from '../actions/actionsType';

const initialState = {
    departments: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ALL_DEPARTMENTS: {
            const departments = action.result.filter((department) => department.disable === false);
            return { ...state, departments };
        }

        default:
            return state;
    }
};

export default reducer;